import {useTranslation} from 'react-i18next';
import {useFetchEsims} from 'hooks/esim/useFetchEsims';
import {useReservation} from 'context/reservation';
import {PurchasedPlan} from './PurchasedPlan';
import cn from 'clsx';

type Props = {
  className?: string;
};
export const MyEsimPlans = ({className}: Props) => {
  const {t} = useTranslation();
  const {data: reservation} = useReservation();
  const {data: esims, isLoading} = useFetchEsims({reservation_id: reservation?.id || ''});

  return isLoading ? (
    <div>{t('loading')}...</div>
  ) : (
    <div className={cn('flex flex-col gap-4 w-full', className)}>
      <h2 className="font-semibold">{t('esim.my.purchased_plans')}</h2>
      <ul className="flex flex-col gap-4">
        {esims?.map(esim => (
          <PurchasedPlan esim={esim} key={esim.id} />
        ))}
      </ul>
    </div>
  );
};
